import {
  Col,
  Row,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import classnames from "classnames";
import SubscriptionsOutlinedIcon from "@mui/icons-material/SubscriptionsOutlined";

import AppModal from "../../Common/AppModal";
import { useHistory } from "react-router-dom";
import Step1 from "./step1/step1";
import Step2 from "./step2/step2";
import Step3 from "./step3/step3";

export default function ManageSubscription({
  modalManageSubscription,
  setModalManageSubscription,
  toggleManageSubscription,
  isEdit,
  setIsEdit,
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [activeVerticalTab, setActiveVerticalTab] = useState(1);
  const toggleVerticalTab = (tab) => {};
  const [chosenPlan, setChosenPlan] = useState([]);
  const [seatsSelected, setSeatsSelected] = useState(0);
  const handleClose = () => {
    setModalManageSubscription(false);
    setIsEdit(false);
  };
  return (
    <AppModal
      open={modalManageSubscription}
      onClose={handleClose}
      title="Subscription"
      icon={<SubscriptionsOutlinedIcon />}
      headerAccent="indigo"
      size="lg"
      hideFooter
    >
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody className="form-steps">
                  <form className="vertical-navs-step">
                    <Row className="gy-5">
                      <Col lg={3}>
                        <Nav className="flex-column custom-nav nav-pills">
                          <NavItem>
                            <NavLink
                              href="#"
                              className={classnames({
                                active: activeVerticalTab === 1,
                                done: activeVerticalTab > 1,
                              })}
                              onClick={() => {
                                setActiveVerticalTab(1);
                              }}
                            >
                              <span className="step-title me-2">
                                <i className="ri-close-circle-fill step-icon me-2"></i>
                                Step 1
                              </span>
                              Choose Plan
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              href="#"
                              className={classnames({
                                active: activeVerticalTab === 2,
                                done: activeVerticalTab >= 2,
                              })}
                              onClick={() => {
                                setActiveVerticalTab(2);
                              }}
                            >
                              <span className="step-title me-2">
                                <i className="ri-close-circle-fill step-icon me-2"></i>
                                Step 2
                              </span>
                              Choose Seats
                            </NavLink>
                          </NavItem>

                          <NavItem>
                            <NavLink
                              href="#"
                              className={classnames({
                                active: activeVerticalTab === 3,
                                done: activeVerticalTab >= 3,
                              })}
                              onClick={() => {
                                setActiveVerticalTab(3);
                              }}
                            >
                              <span className="step-title me-2">
                                <i className="ri-close-circle-fill step-icon me-2"></i>
                                Step 3
                              </span>
                              Payment Details
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </Col>
                      <Col lg={9}>
                        <div className="px-lg-4">
                          <TabContent activeTab={activeVerticalTab}>
                            <TabPane tabId={1}>
                              <Step1
                                chosenPlan={chosenPlan}
                                setChosenPlan={setChosenPlan}
                                activeTab={activeVerticalTab}
                                setActiveTab={setActiveVerticalTab}
                              />
                            </TabPane>
                            <TabPane tabId={2}>
                              {" "}
                              <Step2
                                chosenPlan={chosenPlan}
                                setChosenPlan={setChosenPlan}
                                activeTab={activeVerticalTab}
                                setActiveTab={setActiveVerticalTab}
                                seatsSelected={seatsSelected}
                                setSeatsSelected={setSeatsSelected}
                              />
                            </TabPane>
                            <TabPane tabId={3}>
                              <Step3
                                chosenPlan={chosenPlan}
                                setChosenPlan={setChosenPlan}
                                activeTab={activeVerticalTab}
                                setActiveTab={setActiveVerticalTab}
                                seatsSelected={seatsSelected}
                                setSeatsSelected={setSeatsSelected}
                              />
                            </TabPane>
                          </TabContent>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
    </AppModal>
  );
}
